<template>
  <div>
    <div class="study-Location">
      <div class="DoT-one1"></div>
      <div class="DoT-two2"></div>
      <div class="Training">
        <p>{{$t('i.resume.testResume')}}</p>
      </div>
      <div class="screen">
        <template>
          <!-- <Button class="returnBtn" @click="returnPreviousPage">{{ $t('i.login.returnPrevious') }}</Button> -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "beTold",
    methods:{
      returnPreviousPage(){
        this.$router.back(-1)
      },
    }
  }
</script>

<style scoped>
  .study-Location{
    width: 100%;
    height: 50px;
    position: relative;
    /*background-color: pink;*/
  }
  .DoT-one1{
    width: 10px;
    height: 10px;
    position: absolute;
    left: 85px;
    background-color: #e50020;
  }
  .DoT-two2{
    width: 10px;
    height: 10px;
    position: absolute;
    left: 85px;
    top: 20px;
    background-color: #a8a8a9;
  }

  .Training{
    width: 780px;
    height: 32px;
    position: absolute;
    left: 107px;
  }
  .Training p{
    display: inline-block;
  }
  .Training p:nth-child(1){
    font-size: 30px;
    position: absolute;
    top: -5px;
  }

  .Training p:nth-child(2){
    font-size: 20px;
    color: #969696;
    position: absolute;
    top: 8px;
    left: 220px;
  }
  .screen{
    width: 230px;
    height: 50px;
    float: right;
  }
  .returnBtn{
    height: 35px;
    /*float: right;*/
    /*margin-right: 65px;*/
    margin-top: 15px;
    background-color: #2c8df1;
    color: #fff;
  }
  .screen span:hover{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/pages/resume/components/beTold.vue